import { useState } from 'react';
import { Button, Col, Input, Row } from 'antd';
import { CheckCircleOutlined, ExclamationCircleOutlined, LoadingOutlined } from '@ant-design/icons';

const { TextArea } = Input;

const reasonButtonStates = {
    changed: {type: "danger", icon: (<ExclamationCircleOutlined/>), text: "Absage speichern"},
    saving: {type: "danger", icon: (<LoadingOutlined/>), text: "Absage speichern"},
    saved: {type: "primary", icon: (<CheckCircleOutlined/>), text: "Absage gespeichert"}
};
    
function Reason(props) {

    const [ savedProps, setSavedProps ] = useState({});
    const [ reason, setReason ] = useState("");
    const [ reasonButton, setReasonButton ] = useState(reasonButtonStates.changed);

    if (props !== savedProps) {
        setSavedProps(props);
        setReason(props.reason);
        if (props.reason) {
            setReasonButton(reasonButtonStates.saved);
        }
        else {
            setReasonButton(reasonButtonStates.changed);
        }
    }

    const reasonChanged = (event) => {
        setReason(event.target.value);
        setReasonButton(reasonButtonStates.changed);
    }

    const saveReason = async () => {
        setReasonButton(reasonButtonStates.saving);
        await props.saveReason(reason);
        setReasonButton(reasonButtonStates.saved);
    }    
    
    return (
        <>
        <Row>
          <Col offset={2} span={20}>
            Grund:
          </Col>
        </Row>
        <Row>
          <Col offset={2} span={20}>
            <TextArea 
              allowClear={true}
              disabled={props.disabled}
              rows={4} 
              value={reason} 
              onChange={reasonChanged}
            />
          </Col>
        </Row>
        <Row style={{marginTop: 10, textAlign: "center"}}>
          <Col offset={2} span={20}>
            <Button
              disabled={props.disabled}
              type={reasonButton.type}
              icon={reasonButton.icon}
              onClick={saveReason}
            >
              {reasonButton.text}
            </Button>
          </Col>
        </Row>
      </>
    );
}

export default Reason;